var map = {
	"./course_bg1.png": "ad52",
	"./course_bg2.png": "cbf3",
	"./course_bg3.png": "d40a",
	"./course_bg4.png": "dd94",
	"./course_bg5.png": "b439",
	"./course_bg6.png": "48a3",
	"./course_bg7.png": "5bd3",
	"./course_bg8.png": "f9ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f35";